"use client";
import Image from "next/image";
import React, { useState } from "react";
import trust from "@/public/images/trust.svg";
import SectionHeader from "./SectionHeader";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import { Minus } from "lucide-react";
const TrustInfo = () => {
  const t = useTranslations();
  const [showDescription, setShowDescription] = useState(false);

  return (
    <div
      className={cn(
        "flex items-center rounded-2xl transition-all p-6 bg-green-background relative",
        { "p-2": !showDescription }
      )}
    >
      <Image
        src={trust}
        alt="trust"
        className={cn("transition", { "size-20": !showDescription })}
      />
      <div>
        <div className="flex items-center gap-2">
          <SectionHeader className={"text-start"}>
            {t("trust.title")}
          </SectionHeader>
          <button
            className="absolute btn btn-circle top-2 left-2 md:relative md:top-0 md:left-0 cursor-pointer !size-[25px] min-h-0 text-[14px]"
            onClick={() => setShowDescription(!showDescription)}
          >
            {showDescription ? <Minus /> : t("?")}
          </button>
        </div>
        <p
          className={cn(
            "text-gray-light text-sm h-0 overflow-hidden transition-all",
            {
              "h-auto": showDescription,
            }
          )}
        >
          {t("trust.desc")}
        </p>
      </div>
    </div>
  );
};

export default TrustInfo;
